import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

export default function FooterModalPopup(props) {
    return (
        <Dialog open={props.open} onBackdropClick={props.onDialogClose} onClose={props.onDialogClose} scroll="body" maxWidth='md'>
            <DialogContent className={`${props.isInsideModal ? 'grey-h5' : ''} product-info-dialog-content-footer`}>
                <IconButton className="product-info-close-button" aria-label="close" onClick={props.onDialogClose}>
                    <CloseIcon />
                </IconButton>
                {props.component}
            </DialogContent>
        </Dialog>
    );
}



// WEBPACK FOOTER //
// ./src/components/Footer/FooterModalPopup.js